import React, {Component} from 'react';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import { LinkContainer } from "react-router-bootstrap";

class Top extends Component {
  
render() {        
  return (
    <div className="Top">
        <Navbar collapseOnSelect expand="lg" bg="primary" variant="dark">
             <LinkContainer to="/"><Navbar.Brand>Eleccions al Parlament 2021</Navbar.Brand></LinkContainer>
            <Navbar.Toggle aria-controls="responsive-navbar-nav" />
            <Navbar.Collapse id="responsive-navbar-nav">
                <Nav className="mr-auto">
                <LinkContainer to="/resultats/"><Nav.Link>Municipis</Nav.Link></LinkContainer>
                <LinkContainer to="/bergueda/"><Nav.Link>Berguedà</Nav.Link></LinkContainer>
                <LinkContainer to="/catalunya/"><Nav.Link>Catalunya</Nav.Link></LinkContainer>
                <LinkContainer to="/mapes/"><Nav.Link>Mapes</Nav.Link></LinkContainer>
                <LinkContainer to="/participacio/"><Nav.Link>Participació</Nav.Link></LinkContainer>
                </Nav>
                <Nav>
                <Nav.Link href="https://www.aquibergueda.cat">Aquí Berguedà</Nav.Link>
                </Nav>
            </Navbar.Collapse>
            </Navbar>
  </div>
  );
}

}

export default Top; 